import BaseModifierBehavior from './BaseModifierBehavior';
import { IGameState } from 'State/Game/IGameState';
import LevelStateHelper from 'State/Level/LevelStateHelper';
import CardStateHelper from '../CardStateHelper';
import { isArray } from 'util';

export default class RewardModifierBehavior extends BaseModifierBehavior {
    public onOwnCardPlayed(state: IGameState): IGameState {
        return this.giveReward(state);
    }

    public onOwnCardDiscarded(state: IGameState): IGameState {
        return this.giveReward(state);
    }

    private giveReward(state: IGameState): IGameState {
        if (this.modifier.properties.rewardGiven) return state;
        const rewards = [];
        if (Array.isArray(this.modifier.properties.rewards)) {
            rewards.push(...this.modifier.properties.rewards);
        } else {
            rewards.push(this.modifier.properties.rewards);
        }

        state = LevelStateHelper.addOnLevelCompleteRewards(state, ...rewards);

        let cardsState = this.updateModifier(state.levelState.cardsState, this.cardID, {
            properties: {
                ...this.modifier.properties,
                rewardGiven: true,
            },
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
